


// import React from "react";
// import styled from "styled-components";
// import { FaSearch } from "react-icons/fa";
// import { useTheme } from "../App"; // 🔥 Import the global theme hook

// /* ================= HEADER ================= */
// const HeaderWrapper = styled.header`
//   position: fixed;
//   top: 0;
//   left: ${(props) => (props.collapsed ? "90px" : "260px")};
//   right: 0;
//   height: 88px;
//   padding: 0 28px;
//   background: ${({ $isDarkMode }) => $isDarkMode ? 'rgba(15, 23, 42, 0.96)' : 'rgba(255, 255, 255, 0.96)'};
//   backdrop-filter: blur(12px);
//   border-bottom: 1px solid ${({ $isDarkMode }) => $isDarkMode ? 'rgba(255, 255, 255, 0.1)' : '#e5e7eb'};
//   box-shadow: ${({ $isDarkMode }) => $isDarkMode ? '0 4px 18px rgba(0, 0, 0, 0.2)' : '0 4px 18px rgba(15, 23, 42, 0.06)'};
//   z-index: 90;
//   transition: left 0.3s ease, background 0.3s ease, border-color 0.3s ease, box-shadow 0.3s ease;
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   gap: 24px;

//   @media (max-width: 1024px) {
//     /* MOBILE & TABLET: Relative positioning to flow with the document */
//     position: relative;
//     left: 0 !important;
//     width: 100%;
//     height: auto;
    
//     /* padding-top: 85px pushes the Welcome text safely below the fixed mobile Navbar */
//     /* padding-bottom: 10px keeps the search bar tight to the bottom of this component */
//     padding: 85px 24px 10px; 
    
//     /* THE MAGIC FIX: Pulls the <Main> content up to absorb the huge gap! */
//     margin-bottom: -55px; 
    
//     flex-direction: column;
//     align-items: flex-start;
//     background: transparent;
//     border-bottom: none;
//     box-shadow: none;
//     z-index: 10; 
//     gap: 16px;
//   }

//   @media (max-width: 576px) {
//     padding: 80px 16px 10px; 
//     margin-bottom: -65px; /* Pulls content up even more on tiny screens */
//   }
// `;

// /* ================= LEFT SECTION (GREETING) ================= */
// const LeftSection = styled.div`
//   display: flex;
//   flex-direction: column;
//   justify-content: center;
//   min-width: 0;
//   gap: 6px; /* Perfect, clean spacing between Welcome and Subtitle */
//   width: 100%;
// `;

// const WelcomeText = styled.h1`
//   font-size: 24px; /* Big Main Title */
//   font-weight: 900;
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   margin: 0;
//   line-height: 1.15;
//   white-space: nowrap;
//   overflow: hidden;
//   text-overflow: ellipsis;
//   transition: color 0.3s ease;

//   @media (max-width: 768px) {
//     font-size: 22px;
//     white-space: normal; /* Allows wrapping gracefully on very tiny screens */
//   }
// `;

// const Subtitle = styled.div`
//   font-size: 16px; /* Big and highly visible, but properly proportioned below Welcome */
//   font-weight: 600;
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#60a5fa' : '#2563eb'};
//   line-height: 1.2;
//   transition: color 0.3s ease;

//   @media (max-width: 768px) {
//     font-size: 15px;
//   }
// `;

// /* ================= RIGHT SECTION (SEARCH) ================= */
// const SearchContainer = styled.div`
//   position: relative;
//   width: 280px;
//   flex-shrink: 0;

//   @media (max-width: 1024px) {
//     width: 100%; /* Search seamlessly takes full width on mobile */
//     max-width: 100%;
//   }
// `;

// const Search = styled.input`
//   width: 100%;
//   padding: 10px 12px 10px 36px;
//   border: 1.5px solid ${({ $isDarkMode }) => $isDarkMode ? '#334155' : '#e2e8f0'};
//   border-radius: 20px;
//   font-size: 13px;
//   background: ${({ $isDarkMode }) => $isDarkMode ? '#1e293b' : '#f8fafc'};
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#f8fafc' : '#0f172a'};
//   transition: all 0.2s ease;
//   box-sizing: border-box;

//   &:focus {
//     border-color: #3b82f6;
//     background: ${({ $isDarkMode }) => $isDarkMode ? '#0f172a' : '#fff'};
//     box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
//     outline: none;
//   }

//   &::placeholder {
//     color: ${({ $isDarkMode }) => $isDarkMode ? '#64748b' : '#94a3b8'};
//   }
// `;

// const SearchIcon = styled.div`
//   position: absolute;
//   left: 12px;
//   top: 50%;
//   transform: translateY(-50%);
//   color: ${({ $isDarkMode }) => $isDarkMode ? '#64748b' : '#64748b'};
//   font-size: 14px;
//   display: flex;
//   align-items: center;
//   justify-content: center;
// `;

// /* ================= COMPONENT ================= */
// const DashboardHeader = ({ user, collapsed }) => {
//   // 🔥 GET GLOBAL THEME 🔥
//   const { isDarkMode } = useTheme();

//   // Safely grab Title and First Name
//   const userTitle = user?.title?.trim() || "";
//   const firstName = user?.firstName?.trim() || "";
  
//   // Combine them. If both are blank, fallback to ""
//   const fullName = `${userTitle} ${firstName}`.trim();
//   const displayName = fullName !== "" ? fullName : "";

//   return (
//     // 🔥 PASS THEME STATE TO COMPONENTS 🔥
//     <HeaderWrapper collapsed={collapsed} $isDarkMode={isDarkMode}>
      
//       <LeftSection>
//         <WelcomeText $isDarkMode={isDarkMode}>Welcome, {displayName} </WelcomeText>
//         <Subtitle $isDarkMode={isDarkMode}>You are the best in the 🌍</Subtitle>
//       </LeftSection>

//       <SearchContainer>
//         <SearchIcon $isDarkMode={isDarkMode}>
//           <FaSearch />
//         </SearchIcon>
//         <Search $isDarkMode={isDarkMode} placeholder="Search..." />
//       </SearchContainer>

//     </HeaderWrapper>
//   );
// };

// export default DashboardHeader;










import React, { useState, useEffect } from "react";
import styled from "styled-components";
import {
  FaSearch,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";
import { useTheme } from "../App";

/* ================= SLIDES ================= */

const slides = [
    {
    image:
      "https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/STAwYis2aGd3bG5ZUGlteUowZjY2QT09/2026_SPIRITMAN_SITE_SLIDERS_1.png",
    title: "Stay Productive",
    subtitle: "Achieve your goals every day",
  },
  {
    image:
      "https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/TDdJUHdsOUlRRUlHUEo4S2RNNFJCZz09/2026_SPIRITMAN_SITE_SLIDERS_2B.png",
    title: "Welcome",
    subtitle: "You are the best in the 🌍",
  },
      {
    image:
      "https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/dDlkUnIzZGhXMXEvSVIyMC9QWW5EZz09/2026_SPIRITMAN_SITE_SLIDERS_4b.png",
    title: "Keep Growing",
    subtitle: "Learning never stops",
  },
  {
    image:
      "https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/KzJnZjVkcWFFZmNUbkk0MEc4K0pjUT09/2026_SPIRITMAN_SITE_SLIDERS_3.png",
    title: "Keep Growing",
    subtitle: "Learning never stops",
  },
    {
    image:
      "https://cdn1.kingschat.online/uploads/media/57fbe8f538da4d5569ad1cff/VXIxUWVYeHU1S3UwU0xHUTQyT2cxZz09/2026_SPIRITMAN_SITE_SLIDERS_5.png",
    title: "Keep Growing",
    subtitle: "Learning never stops",
  },
];
/* ================= WRAPPER ================= */
/* ================= WRAPPER ================= */
const SliderWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 340px;
  overflow: hidden;
  border-radius: 24px;
  margin-top: 5px;
  justify-content: center; /* Fixed typo (comma changed to semicolon) */

  @media (max-width: 768px) {
    /* Let the height adjust automatically based on the width */
    height: auto;
    aspect-ratio: 16 / 8; 
    min-height: 270px;
    border-radius: 18px;
  }
`;

const Slide = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  inset: 0;

  background-image: ${({ image }) => `url(${image})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat; /* Prevents tiling */

  opacity: ${({ active }) => (active ? 1 : 0)};
  transition: opacity 0.8s ease;

  @media (max-width: 768px) {
    /* Guarantees the entire image fits on the screen without being cropped */
    background-size: contain; 
  }
`;



const Overlay = styled.div`
  position: absolute;
  inset: 0;
  ${'' /* background: linear-gradient(
    rgba(0, 0, 0, 0.2),
    rgba(0, 0, 0, 0.6)
  ); */}
`;

/* ================= CONTENT ================= */

const Content = styled.div`
  position: absolute;
  top: 50%;
  left: 50px;
  transform: translateY(-50%);
  color: white;
  z-index: 5;
  max-width: 650px;

  @media (max-width: 768px) {
    left: 20px;
    right: 20px;
  }
`;

const WelcomeText = styled.h1`
  font-size: 42px;
  font-weight: 800;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    font-size: 28px;
  }
`;

const Subtitle = styled.p`
  font-size: 18px;
  margin-bottom: 25px;
  opacity: 0.95;

  @media (max-width: 768px) {
    font-size: 15px;
  }
`;

/* ================= SEARCH ================= */

const SearchContainer = styled.div`
  position: relative;
  width: 350px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const Search = styled.input`
  width: 100%;
  padding: 12px 15px 12px 42px;
  border-radius: 50px;
  border: none;
  outline: none;
  font-size: 14px;
`;

const SearchIcon = styled.div`
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
  color: #64748b;
`;

/* ================= CONTROLS ================= */

const ControlButton = styled.button`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 45px;
  height: 45px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  z-index: 10;

  background: rgba(255,255,255,0.2);
  backdrop-filter: blur(10px);
  color: white;

  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background: rgba(255,255,255,0.35);
  }
`;

const PrevButton = styled(ControlButton)`
  left: 20px;
`;

const NextButton = styled(ControlButton)`
  right: 20px;
`;

/* ================= DOTS ================= */

const Dots = styled.div`
  position: absolute;
  bottom: 18px;
  width: 100%;
  display: flex;
  justify-content: center;
  gap: 10px;
  z-index: 10;
`;

const Dot = styled.div`
  width: ${({ active }) => (active ? "30px" : "10px")};
  height: 10px;
  border-radius: 20px;
  cursor: pointer;

  background: ${({ active }) =>
    active ? "#ffffff" : "rgba(255,255,255,0.5)"};

  transition: all 0.3s ease;
`;

/* ================= COMPONENT ================= */

const DashboardHeader = ({ user }) => {
  const { isDarkMode } = useTheme();

  const [current, setCurrent] = useState(0);

  const userTitle = user?.title || "";
  const firstName = user?.firstName || "";
  const displayName = `${userTitle} ${firstName}`.trim();

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) =>
        prev === slides.length - 1 ? 0 : prev + 1
      );
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  const nextSlide = () => {
    setCurrent((prev) =>
      prev === slides.length - 1 ? 0 : prev + 1
    );
  };

  const prevSlide = () => {
    setCurrent((prev) =>
      prev === 0 ? slides.length - 1 : prev - 1
    );
  };

  return (
    <SliderWrapper>
      {slides.map((slide, index) => (
        <Slide
          key={index}
          image={slide.image}
          active={index === current}
        >
          <Overlay />
        </Slide>
      ))}

      <Content>

      </Content>

      <PrevButton onClick={prevSlide}>
        <FaChevronLeft />
      </PrevButton>

      <NextButton onClick={nextSlide}>
        <FaChevronRight />
      </NextButton>

      <Dots>
        {slides.map((_, index) => (
          <Dot
            key={index}
            active={current === index}
            onClick={() => setCurrent(index)}
          />
        ))}
      </Dots>
    </SliderWrapper>
  );
};

export default DashboardHeader;